export const formatStringNumber = (x: string|undefined) => x ?
  x.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';

export const formatNumber = (x: number|undefined, decimalPlaces = 2) => x ? formatStringNumber(x.toFixed(decimalPlaces)) : '0';
